<section class="flex flex-col items-center gap-12">
  <app-section-header
    [description]="
      'Build your apps from the command line with our powerful CLI'
    "
    [icon]="'@tui.terminal'"
    [subtitle]="'CLI'"
    [title]="'Start building with a single command'"
  >
  </app-section-header>
  <div class="w-full text-base">
    <div
      class="flex justify-between rounded-t-[--tui-radius-l] bg-[#1E1E1E] p-4"
    >
      <div class="flex flex-row items-center gap-4">
        <div class="h-3 w-3 rounded-full bg-[#FF5F56]"></div>
        <div class="h-3 w-3 rounded-full bg-[#FFBD2E]"></div>
        <div class="h-3 w-3 rounded-full bg-[#27C93F]"></div>
      </div>
      <span class="font-bold text-white">terminal</span>
      <div></div>
    </div>
    <div
      class="h-80 overflow-y-auto rounded-b-[--tui-radius-l] bg-[#121212] p-4 font-mono text-sm md:p-6"
    >
      @for (line of terminalOutput; track $index) {
        <div class="mb-1 text-white">
          @if (line.type === "command") {
            <span>{{ line.text }}</span>
          } @else if (line.type === "info") {
            <span class="text-[#9CDCFE]">[INFO]</span>
            <span> {{ line.text }}</span>
          } @else if (line.type === "success") {
            <span class="text-[#4EC9B0]">[SUCCESS]</span>
            <span> {{ line.text }}</span>
          } @else if (line.type === "output") {
            <span>{{ line.text }}</span>
          }
        </div>
      }
    </div>
  </div>
</section>
